import React,{useState,useEffect} from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import RemoveIcon from '@mui/icons-material/Remove';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import useStyles from './Styles';
import DatePick from './DatePick';
import {Dataset} from './Inc';
import {Tools} from './Tools';

interface Props {
	name: string,
	value?: string,
	error?: string,
	label?: string,
	id: string,
	list?: Dataset[],
	words?: string[],
	type: "text" | "textarea" | "select" | "radio" | "date" | "switch" | "segment" | "kana",
	required?:boolean,
	fullWidth?:boolean,
	startAdornment?:string,
	endAdornment?:string,
	notEmpty?:boolean,
	frontHelper?:string,
	helper?:string,
	maxLength?:number,
	minLength?:number;
	maxRange?:number,
	minRange?:number,
	rows?:number,
	segment?: segmentParams,
	dense?:boolean,
	filled?: boolean,
	placeholder?: string,
	disabled?:boolean,
	enableTags?:boolean,
	change(name:string,value:string): void,
	addError?(name:string,flag:boolean): void,
	blur?(): void,
	focus?(): void,
	disabledIds?: string[],
}

interface segmentParams {
	width?:string,
	maxWidth?:string,
	widths?:string[],
	maxLengths?:number[],
	placeholder?:string[],
	required?:boolean[],
	separator?:string,
}

const ColInput:React.FC<Props> = (props)=> {
	const classes = useStyles();
	////let error = "";
	//let value = "";
	// if( props.value && props.value!=='undefined' ){
	// 	value = props.value;
	// }

	const [states,setStates] = useState({
		error: props.error || "",
		value: (props.value && props.value!=='undefined') && props.value || "",
		isCalendar: false,
	});

	const change = (event: React.ChangeEvent<HTMLInputElement>) => {
		if( !event || !event.target ){
			return;
		}
		const value = event.target.value;
		//console.log("change",value);
		setStates(prev=>({...prev,"value":value}));
	};
	const changeSegment = (index:number)=> (event: React.ChangeEvent<HTMLInputElement>) => {
		if( !event || !event.target ){
			return;
		}
		if( !props.segment || !props.segment.required ){
			return;
		}
		const value = event.target.value;
		const sp = states.value.split('-');
		for( let i=0; i<props.segment.required.length	; i++ ){
			if( !sp[i] ){
				sp[i] = "";
			}
		}
		sp[index] = value;
		setStates(prev=>({...prev,"value":sp.join('-')}));
	};
	const changeSelect = (event: SelectChangeEvent) => {
		if( !event || !event.target ){
			return;
		}
		const value = event.target.value;
		setStates(prev=>({...prev,"value":value}));
		finish(value);
	};
	const changeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
		if( !event || !event.target ){
			return;
		}
		const value = String(event.target.value);
		setStates(prev=>({...prev,"value":value}));
		finish(value);
	};
	const changeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
		let v = "0";
		if( event.target.checked ){
			v = "1";
		}
		setStates(prev=>({...prev,value:v}));
		finish(v);
	};
	const changeDate = (dt:string) => {
		setStates(prev=>({...prev,value:dt,isCalendar:false}));
		finish(dt);
	}

	const finish = (value:string)=>{
		validate(value);
		props.change(props.id,value);
		if( props.blur ){
			props.blur();
		}
	}

	const blur = ()=>{
		let value =states.value;
		if( props.type==="kana") {
			value = (states.value || "").replace(/[^\u30A0-\u30FF\u3000\sー－]/g, "");
			setStates(prev => ({ ...prev, value: value }));
		}
		//console.log("finish",value);
		finish(value);
	}

	const focus = ()=>{
		if( props.focus ){
			props.focus();
		}
	}
	const openCalendar = ()=>{
		setStates(prev=>({...prev,isCalendar:true}));
	}
	const closeCalendar = ()=>{
		setStates(prev=>({...prev,isCalendar:false}));
	}
	const validate = (newValue?:string)=>{
		let error = "";
		if( props.error ){
			error = props.error;
			//console.log("error",error);
		}

		let value = "";
		if( newValue ){
			if( props.enableTags ){
				value = newValue;
			} else {
				value = Tools.stripTags(newValue);
			}
		}

		if( props.type==="segment" && props.segment && props.segment.required ){
			const sp = value.split('-');
			for( let i=0; i<props.segment.required.length; i++ ){
				if( sp[i]==="" && props.segment.required[i] ){
					error = "省略できません";
					break;
				}
				if( props.segment.maxLengths && props.segment.maxLengths[i] && sp[i].length > props.segment.maxLengths[i] ){
					error = "文字数を確認して下さい（最大5文字-1文字-8文字）";
					break;
				}
			}
		} else {
			if( required && value==="" ){
				error = "省略できません";
			}
		}
		if( props.maxRange || props.maxRange===0 ){
			if( value!=="" ){
				if( parseInt(value) > props.maxRange ){
					error = String(props.maxRange) + "以下にして下さい";
				}
			}
		}
		if( props.minRange || props.minRange===0 ){
			if( value!=="" ){
				if( parseInt(value) < props.minRange ){
					error = String(props.minRange) + "以上にして下さい";
				}
			}
		}

		let length = 0;
		if( value!=="" ){
			length = value.length;
			if( props.type==="segment" && props.segment && props.segment.required ){
				length -= props.segment.required.length - 1; // remove hyphens
			}
		}

		if( props.maxLength || props.maxLength===0 ){
			if( value!=="" ){
				if( length > props.maxLength ){
					error = String(props.maxLength) + "文字以内にして下さい";
				}
			}
		}
		if( props.minLength || props.minLength===0 ){
			if( value!=="" ){
				if( length < props.minLength ){
					error = String(props.minLength) + "文字以上にして下さい";
				}
			}
		}
		if( props.type==="date" && value!=="" ){
			if(!value.match(/^\d{4}[-\/]\d{1,2}[\/-]\d{1,2}$/)){
				error = "存在する日付を入力して下さい";
			}
		}
		if( error !=="" ){
			if( props.addError ){
				props.addError(props.id,true);
			}
			setStates(prev=>({...prev,value:value,error:error}));
			return true;
		} else {
			if( props.addError ){
				props.addError(props.id,false);
			}
			setStates(prev=>({...prev,value:value,error:""}));
			return false;
		}
	}



	let required = false;
	if( props.required && props.required===true ){
		required = true;
	}

	let notEmpty = false;
	if( required ){
		notEmpty = true;
	} else if( props.notEmpty && props.notEmpty===true ){
		notEmpty = true;
	}

	let inputProps = {};
	if( props.startAdornment && props.endAdornment ){
		inputProps = {
			endAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="end">{props.endAdornment}</InputAdornment>,
			startAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="start">{props.startAdornment}</InputAdornment>,
		}
	} else if( props.endAdornment ){
		inputProps = {
			endAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="end">{props.endAdornment}</InputAdornment>,
		}
	} else if( props.startAdornment ){
		inputProps = {
			startAdornment: <InputAdornment style={{whiteSpace:"nowrap"}} position="start">{props.startAdornment}</InputAdornment>,
		}
	} else if( props.type==="date" ){
		inputProps = {
			endAdornment: 
			<InputAdornment position="end">
				<IconButton
					aria-label="toggle password visibility"
					onClick={openCalendar}
					onMouseDown={openCalendar}
				>
					<FontAwesomeIcon icon="calendar-alt"/>
				</IconButton>
			</InputAdornment>
			,
		}
	}

	let name = "　";
	if( props.name ){
		name = props.name;
	}

	let rows = 3;
	if( props.rows ){
		rows = props.rows;
	}

	let style = {marginBottom:"1.5em"};
	if( props.dense ){
		style = {marginBottom:"0em"};
	}

	//validate();
	const wordList = [] as Dataset[];
	if( props.type==="radio" || props.type==="select" ){
		if( props.list && props.list.length > 0 ){
			props.list.forEach((data:Dataset)=>{
				if( data.id && data.label ){
					wordList.push(data);
				}
			});
		} else if( props.words && props.words.length > 0 ){
			props.words.forEach((word:string,index:number)=>{
				wordList.push({id:word,label:word});
			});
		}
	}

	useEffect(() => {
		setStates(prev => ({ ...prev, value: props.value ?? "" }));
	}, [props.value]);

	useEffect(() => {
		setStates(prev => ({ ...prev, value: props.value ?? "", error: props.error ?? "" }));
	}, [props.id]);

	return (
	<React.Fragment>
		<FormControl fullWidth={true} error={states.error!==""} style={style}>
			{!props.filled &&
			<FormLabel component="label" className={classes.formLabel}>{name}
			{required && <span className="formRequired">必須</span>}
			</FormLabel>
			}
			{props.frontHelper &&
			<FormHelperText className={classes.helper} error={false} style={{marginBottom:'1em'}}>{props.frontHelper}</FormHelperText>
			}
			{(props.type==="text" && !props.filled) &&
			<TextField
				id={props.id}
				value={states.value}
				onChange={change}
				onBlur={blur}
				onFocus={focus}
				margin="dense"
				InputProps={inputProps}
				variant="standard"
				placeholder={props.placeholder ? props.placeholder : ""}
				disabled={props.disabled && props.disabled===true || false}
				//variant="filled"
				//label={name}
			/>
			}
			{(props.type==="text" && props.filled) &&
			<TextField
				id={props.id}
				value={states.value}
				onChange={change}
				onBlur={blur}
				onFocus={focus}
				margin="dense"
				InputProps={inputProps}
				variant="filled"
				label={name}
				placeholder={props.placeholder ? props.placeholder : ""}
				disabled={props.disabled && props.disabled===true || false}
			/>
			}

			{props.type==="kana" &&
			<TextField
				id={props.id}
				value={states.value}
				onChange={change}
				onBlur={blur}
				margin="dense"
				variant="standard"
				placeholder={props.placeholder ? props.placeholder : ""}
				inputProps={{ inputMode: "katakana" }}
				disabled={props.disabled && props.disabled===true || false}
			/>
			}

			{(props.type==="segment") &&
			<Box display="flex" flexDirection="row" alignItems="center"
				justifyContent="space-between"
				style={{
					maxWidth:props.segment && props.segment.maxWidth ? props.segment.maxWidth : "100%",
					width:props.segment && props.segment.width ? props.segment.width : "100%",
				}}>
				{props.segment &&props.segment.required && props.segment.required.length>0 &&
				<TextField
					id={props.id+"_tri0"}
					value={states.value ? states.value.split('-')[0] : ""}
					onChange={changeSegment(0)}
					onBlur={blur}
					onFocus={focus}
					margin="dense"
					InputProps={inputProps}
					variant="standard"
					placeholder={props.segment && props.segment.placeholder && props.segment.placeholder[0] ? props.segment.placeholder[0] : ""}
					disabled={props.disabled && props.disabled===true || false}
					style={{width:props.segment && props.segment.widths && props.segment.widths[0] ? props.segment.widths[0] : '25%'}}
				/>}
				{props.segment && props.segment.required && props.segment.required.length>1 &&
				<>
				<RemoveIcon/>
				<TextField
					id={props.id+"_tri1"}
					value={states.value && states.value.split('-').length>1 ? states.value.split('-')[1] : ""}
					onChange={changeSegment(1)}
					onBlur={blur}
					onFocus={focus}
					margin="dense"
					InputProps={inputProps}
					variant="standard"
					placeholder={props.segment && props.segment.placeholder && props.segment.placeholder[1] ? props.segment.placeholder[1] : ""}
					disabled={props.disabled && props.disabled===true || false}
					style={{width:props.segment && props.segment.widths && props.segment.widths[1] ? props.segment.widths[1] : '25%'}}
				/>
				</>}
				{props.segment && props.segment.required && props.segment.required.length>2 &&
				<>
				<RemoveIcon/>
				<TextField
					id={props.id+"_tri2"}
					key={props.id+"_tri2"}
					value={states.value && states.value.split('-').length>2 ? states.value.split('-')[2] : ""}
					onChange={changeSegment(2)}
					onBlur={blur}
					onFocus={focus}
					margin="dense"
					InputProps={inputProps}
					variant="standard"
					placeholder={props.segment && props.segment.placeholder && props.segment.placeholder[2] ? props.segment.placeholder[2] : ""}
					disabled={props.disabled && props.disabled===true || false}
					style={{width:props.segment && props.segment.widths && props.segment.widths[2] ? props.segment.widths[2] : '25%'}}/>
				</>}
				{props.segment && props.segment.required && props.segment.required.length>3 &&
				<>
				<RemoveIcon/>
				<TextField
					id={props.id+"_tri3"}
					key={props.id+"_tri3"}
					value={states.value && states.value.split('-').length>3 ? states.value.split('-')[3] : ""}
					onChange={changeSegment(3)}
					onBlur={blur}
					onFocus={focus}
					margin="dense"
					InputProps={inputProps}
					variant="standard"
					placeholder={props.segment && props.segment.placeholder && props.segment.placeholder[3] ? props.segment.placeholder[3] : ""}
					disabled={props.disabled && props.disabled===true || false}
					style={{width:props.segment && props.segment.widths && props.segment.widths[3] ? props.segment.widths[3] : '25%'}}
				/>
				</>}
			</Box>
			}

			{props.type==="date" &&
			<TextField
				id={props.id}
				value={states.value}
				onChange={change}
				onFocus={focus}
				onBlur={blur}
				margin="dense"
				variant="standard"
				InputProps={inputProps}
				disabled={props.disabled && props.disabled===true || false}
				//variant="outlined"
			/>
			}

			{props.type==="select" &&
				<Select
					value={states.value}
					onChange={changeSelect}
					inputProps={{
						name: props.id,
						id: props.id,
					}}
					margin="none"
					variant="standard"
					style={{marginTop:"0.3em"}}
					disabled={props.disabled && props.disabled===true || false}
				>
					{!notEmpty &&
					<MenuItem key="option0" value=""></MenuItem>
					}
					{wordList &&
						wordList.map((option:Dataset,index:number) => {
							const key = "option"+index;
							return (
								<MenuItem key={key} value={option.id}>
									{option.label}
								</MenuItem>
							)
						})
					}
				</Select>
			}


			{props.type==="textarea" &&
			<TextField
				id={props.id}
				value={states.value}
				onChange={change}
				onBlur={blur}
				margin="dense"
				rows={rows}
				disabled={props.disabled && props.disabled===true || false}
				//variant="outlined"
				multiline
			/>
			}

			{props.type==="radio" &&
			<RadioGroup
				row
				className={classes.radiogroup}
				value={states.value}
			>
				{wordList &&
						wordList.map((data:Dataset,index:number)=>{
						const key = "radio"+index;
						return (
							<FormControlLabel key={key} value={data.id} control={<Radio color="primary" disabled={(props.disabledIds && props.disabledIds.includes(data.id)) || (props.disabled && props.disabled===true)} onChange={changeRadio}/>} label={data.label} />
						);
				})}
			</RadioGroup>
			}

			{props.type==="switch" &&
			<FormControlLabel
				control={
				<Switch
					checked={states.value==="1"}
					onChange={changeSwitch}
					value="1"
					color="primary"
				/>
				}
				label={props.label}
			/>
			}

			{props.helper && states.error==="" &&
			<FormHelperText className="formHelperNormal">※{props.helper}</FormHelperText>
			}
			{states.error!=="" &&
			<FormHelperText className="formHelperError">※{states.error}</FormHelperText>
			}
		</FormControl>
		<DatePick isOpen={states.isCalendar} close={closeCalendar} change={changeDate} value={states.value}/>
	</React.Fragment>
	);
}

export default ColInput;
